import { SyncVerb } from '../types/Verbs';
import { CollectionSyncRedux, SyncRedux } from './types';
import { createCollectionSyncReducer, createSyncReducer } from '../reducers/lib';
import { createSyncActionCreator, createSyncActionCreatorDataValue } from '../actionCreators/lib';
import { CreateSyncReduxOptions, UnionedCollectionSyncReduxOptions } from '../slice/types';

export function createSyncRedux<SV extends SyncVerb, N extends string, T, RQ = void>(
	options: CreateSyncReduxOptions<SV, N, T, RQ>
): SyncRedux<SV, N, T, RQ> {
	return {
		syncActionCreator: createSyncActionCreatorDataValue<SV, N, RQ>({
			name: options.name,
			syncVerb: options.syncVerb as SV
		}),
		syncReducer: createSyncReducer<SV, N, T, RQ>(options)
	};
}

export function createCollectionSyncRedux<SV extends SyncVerb, N extends string, T, RQ = void>(
	options: UnionedCollectionSyncReduxOptions<N, T, RQ>
): CollectionSyncRedux<SV, N, T, RQ> {
	return {
		syncActionCreator: createSyncActionCreator<SV, N, RQ>({
			hasRequest: options.hasRequest,
			name: options.name,
			syncVerb: options.syncVerb as SV
		}),
		syncReducer: createCollectionSyncReducer<SV, N, T, RQ>(options)
	};
}
